import React from 'react';
import '../css/modal.css';

const Modal = ({children, onClickCloseBtn}) => {
    return (
        <div className='modal-page'>
            <div className='modal-content'>
                <div className='close-btn-container'>
                    <button className='close-btn' onClick={onClickCloseBtn}>&times;</button>
                </div>
                {children}
            </div>
        </div>
    );
}

export default Modal;
